import Select from "./Card/Select";

export default Object.assign({}, { Select });
